<template>
  <div class="loyalty-tab__purchases">
    <SearchHeader
      :placeholder="$t('loyalty.text.27')"
      @init-search="doSearch"
    />
    <div
      v-if="all"
      class="purchases__content"
    >
      <div class="content__part">
        <div v-if="selected" class="purchases__check-full">
          <div class="check-full__header purchases__row">
            <span>
              {{ $t('loyalty.text.24') }} <b>#{{ selected.number }}</b> {{ $t('loyalty.text.25') }} <b>{{ selected.sum }}&nbsp;₽</b> 
            </span>
            <span class="row__time">{{ selected.createdOn }}</span>
          </div>
          <div class="check-full__content">
            <span class="content__row--small">
              {{ $t('loyalty.text.26') }} <b>{{ selected.location }}</b>
            </span>
            <span class="content__row--small">
              {{ $t('loyalty.text.28') }} <b>{{ selected.seller }}</b>
            </span>
            <span class="content__row--small">
              {{ $t('loyalty.text.29') }} <b>{{ selected.param3 }}</b>
            </span>
            <div class="check-full__products-wrapper">
              <div
                v-for="(item, index) in selected.items"
                :key="index"
                class="check-full__product">
                <img :src="item.img" alt="product" width="35" height="35">
                <div class="product__text">
                  <span class="product__title">
                    {{ item.title }}
                  </span>
                  <span class="product__serial">
                    {{ $t('loyalty.text.30') }} {{ item.serialNum }}
                  </span>
                </div>
                <div class="product__numbers">
                  <span class="product__sum">{{ item.sum }}&nbsp;₽</span>
                  <span class="product__bonus">-{{ item.bonusOff }}&nbsp;B</span>
                </div>
              </div>
            </div>
            <div class="content__row--small content__row--flex">
              <span>{{ $t('loyalty.text.31') }}</span>
              <span>{{ selected.totalSum }}&nbsp;₽</span>
            </div>
            <div class="content__row--small content__row--flex">
              <span>{{ $t('loyalty.text.32') }}</span>
              <span class="check-full__bonus-off">
                -{{ selected.bonusOff }}&nbsp;B
              </span>
            </div>
            <div class="content__row--large content__row--flex">
              <span>{{ $t('loyalty.text.33') }}</span>
              <span>
                {{ selected.totalSum - selected.bonusOff }}&nbsp;₽
              </span>
            </div>
            <div class="content__row--small content__row--flex">
              <span>{{ $t('loyalty.text.34') }}</span>
              <span class="check-full__bonus-on">
                +{{ selected.bonusOn }}&nbsp;B
              </span>
            </div>
          </div>
        </div>
        <Spinner v-else type="dots" />
      </div>
      <perfect-scrollbar class="content__part check__all-rows">
        <div
          v-for="(item, index) in all"
          :key="index"
          class="purchases__row purchases__row-button"
          :class="selected && selected.id === item.id ? 'purchases__row-button--active' : ''"
          @click="setSelected(item.id)"
        >
            <span>
              {{ $t('loyalty.text.24') }} <b>#{{ item.number }}</b> {{ $t('loyalty.text.25') }} <b>{{ item.sum }}&nbsp;₽</b>
            </span>
          <span class="row__time">{{ item.createdOn }}</span>
        </div>
      </perfect-scrollbar>
    </div>
    <Spinner
      v-else
      position="relative"
    />
  </div>
</template>

<script>
import clientAllPurchases from "@/mockData/clientAllPurchases.json";
import clientPurchase from "@/mockData/clientPurchase.json";

import ScrollContent from "@/manzana_library/components/Elements/ScrollContent";
import SearchHeader from "@/components/SearchHeader.vue";
import Spinner from "@/manzana_library/components/Widgets/Spinner.vue";

export default {
  components: {
    SearchHeader,
    Spinner
  },
  data() {
    return {
      all: null,
      selected: null
    }
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      setTimeout(() => {
        this.all = clientAllPurchases.data;
        this.setSelected(this.all[0].id);
      }, 3000);
    },
    setSelected(id) {
      this.selected = null;
      setTimeout(() => {
        this.selected = clientPurchase.data;
        this.selected.id = id;
      }, 3000);
    },
    doSearch(searchQuery) {
      console.log(searchQuery);
    }
  }
}
</script>

<style lang="scss" scoped>
.loyalty-tab__purchases {
  padding: 0 10px;

  .search-header {
    margin-bottom: 20px;
  }

  .spinner-dots {
    margin: 0 auto;
  }
  .purchases {
    &__content {
      display: flex;
      .content__part {
        width: 50%;
        &:first-of-type {
          margin-right: 25px;
        }
      }
    }
    &__row {
      color: #000000;
      padding: 12px 20px;
      display: flex;
      justify-content: space-between;
      b {
        color: $color_green-new;
      }
      .row__time {
        color: $color_gray;
      }
    }
    &__row-button {
      border: 1px solid #DDDDDD;
      border-radius: 3px;
      margin-bottom: 15px;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      &--active,
      &:hover,
      &:active,
      &:target {
        border: 1px solid $color_green-new;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05), 4px 0px 10px rgba(0, 0, 0, 0.05), -4px 0px 10px rgba(0, 0, 0, 0.05), 0px -4px 10px rgba(0, 0, 0, 0.05);
      }
    }
    &__check-full {
      border: 1px solid $color_green-new;
      border-radius: 3px;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05), 4px 0px 10px rgba(0, 0, 0, 0.05), -4px 0px 10px rgba(0, 0, 0, 0.05), 0px -4px 10px rgba(0, 0, 0, 0.05);
      .purchases__row {
        border-bottom: 1px solid $color_green-new;
      }
    }
  }
  .check-full {
    &__content {
      line-height: 20px;
      padding: 7px 20px 17px;
    }
    &__products-wrapper {
      border-top: 1px solid #DDDDDD;
      margin-top: 20px;
    }
    &__product {
      padding: 10px 0;
      border-bottom: 1px solid #DDDDDD;
      display: flex;
      img {
        width: 35px;
        height: 35px;
        margin-right: 10px;
      }
    }
    &__bonus-on {
      color: $color_green-new;
    }
    &__bonus-off {
      color: #FF5C00;
    }
  }
  .product {
    &__text {
      display: flex;
      flex-direction: column;
      margin-right: 10px;
    }
    &__numbers {
      display: flex;
      flex-direction: column;
      text-align: right;
      margin-left: auto;
    }
    &__serial {
      font-size: 12px;
      color: $color_gray;
      line-height: 15px;
    }
    &__bonus {
      font-size: 12px;
      color: #FF5C00;
      line-height: 15px;
    }
  }
  .content {
    &__row {
      @include text(
          $font-family_sans_ui,
          13px,
          $font-weight_sans_ui_regular
      );
      &--small {
        color: #000000;
        display: block;
        margin: 9px 0;
        @include text(
            $font-family_sans_ui,
            13px,
            $font-weight_sans_ui_regular
        );
        b {
          color: $color_green-new;
        }
      }
      &--flex {
        display: flex;
        justify-content: space-between;
        span:first-child {
          padding-right: 10px;
        }
      }
      &--large {
        color: #000000;
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
  .check__all-rows {
    height: 450px;
  }
}
</style>
